function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
export default function ListItem(props) {
  var _rootCls;

  var onSelect = props.onSelect,
      prefixCls = props.prefixCls,
      disabled = props.disabled,
      name = props.name,
      multiple = props.multiple,
      icon = props.icon,
      addBtn = props.addBtn;
  var rootCls = (_rootCls = {}, _defineProperty(_rootCls, prefixCls, 1), _defineProperty(_rootCls, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_rootCls, "".concat(prefixCls, "-add-btn"), addBtn), _defineProperty(_rootCls, "".concat(prefixCls, "-multiple"), multiple), _rootCls);

  function selectHandle(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!disabled) {
      onSelect();
    }
  }

  return React.createElement("li", {
    className: classNames(rootCls),
    title: name,
    onClick: function onClick(event) {
      return selectHandle(event);
    }
  }, name);
}
ListItem.propTypes = {
  prefixCls: PropTypes.string
};
ListItem.defaultProps = {
  prefixCls: 'mkui-transfer-modal-item'
};
//# sourceMappingURL=ListItem.js.map
